// This file is automatically generated. Do not edit manually.

import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationCachePurgeApi {
	export async function purgePartConfigurationCache(args: {
		partConfigurationId: number;
		configuratorType: PartConfiguratorType;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/cachePurge/purgePartConfigurationCache",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
				configuratorType: args.configuratorType,
			},
		});
		return response as void;
	}
}
